'use strict';

var debounce = require('lodash/debounce');
var minChars = 1;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;
var NOSTO_AUTOCOMPLETE_LIMIT = 6;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).siblings('.suggestions-wrapper');
}

function getSuggestionsEndpoint(scope) {
    return getSuggestionsWrapper(scope).data('url') || '';
}

function getAutocompleteProvider(scope) {
    var provider = getSuggestionsWrapper(scope).data('autocomplete-provider');

    if (!provider) {
        return 'sfcc';
    }

    provider = String(provider).toLowerCase();
    return provider === 'sfcc' ? 'sfcc' : 'nosto';
}

function escapeHtml(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function extractNostoSearchNode(response) {
    if (response && response.products) {
        return response;
    }

    if (response && response.data && response.data.search) {
        return response.data.search;
    }

    return null;
}

function getNostoHitField(hit, keys) {
    var i;

    if (!hit || !keys || !keys.length) {
        return '';
    }

    for (i = 0; i < keys.length; i++) {
        if (hit[keys[i]]) {
            return String(hit[keys[i]]);
        }
    }

    return '';
}

function buildNostoSuggestionsMarkup(searchTerm, hits) {
    var products = [];
    var i;
    var id;
    var url;
    var name;
    var imageUrl;
    var itemsMarkup;
    var countMessage;

    for (i = 0; i < hits.length && products.length < NOSTO_AUTOCOMPLETE_LIMIT; i++) {
        id = getNostoHitField(hits[i], ['productId', 'productID', 'product_id', 'id']);
        url = getNostoHitField(hits[i], ['url', 'productUrl', 'product_url']);
        name = getNostoHitField(hits[i], ['name', 'title', 'productName']) || id;
        imageUrl = getNostoHitField(hits[i], ['imageUrl', 'image_url', 'image']);

        if (!name || !url) {
            continue;
        }

        products.push({
            name: name,
            url: url,
            imageUrl: imageUrl
        });
    }

    if (!products.length) {
        return null;
    }

    itemsMarkup = products.map(function (product, index) {
        var imageMarkup = '';

        if (product.imageUrl) {
            imageMarkup = '<img class="swatch-circle" alt="" src="' + escapeHtml(product.imageUrl) + '" />';
        }

        return '' +
            '<li class="col-12 item" id="product-' + index + '" role="option">' +
                '<a href="' + escapeHtml(product.url) + '" aria-label="' + escapeHtml(product.name) + '" class="link">' +
                    '<div class="col-xs-12 ellipsis">' +
                        imageMarkup +
                        '<span class="name">' + escapeHtml(product.name) + '</span>' +
                    '</div>' +
                '</a>' +
            '</li>';
    }).join('');

    countMessage = products.length + ' results found for ' + searchTerm;

    return '' +
        '<div class="suggestions">' +
            '<ul class="container" role="listbox" id="search-results">' +
                '<li class="row header">' +
                    '<div class="col-xs-12 col-sm-10 search-phrase">Search results for <em>' +
                        escapeHtml(searchTerm) +
                    '</em></div>' +
                '</li>' +
                '<li class="row justify-content-end items">' +
                    '<ul class="col-12 list">' +
                        itemsMarkup +
                    '</ul>' +
                '</li>' +
            '</ul>' +
            '<span id="search-result-count" class="sr-only">' + escapeHtml(countMessage) + '</span>' +
        '</div>';
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length && $(window).width() < 992;
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $('body').removeClass('modal-open');
    $('header').siblings().attr('aria-hidden', 'false');
    $('.suggestions').removeClass('modal');
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $('body').addClass('modal-open');
        $('header').siblings().attr('aria-hidden', 'true');
        getSuggestionsWrapper(scope).find('.suggestions').addClass('modal');
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $('input.search-field').val('');
    clearModals();
    $('.search-mobile .suggestions').unbind('scroll');
    $('.suggestions-wrapper').empty();
    $('.search-mobile').find('.site-search').removeClass('active');
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile button.';
    var iconSearch = 'fa-search';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr('type', 'button');
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr('type', 'submit');
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find('.suggestions');
        $suggestions.css('top', top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    // $.spinner().stop();

    if (typeof (response) !== 'object') {
        $suggestionsWrapper.append(response).show();
        $(this).siblings('.reset-button').addClass('d-lg-block');
        positionSuggestions(this);

        if (isMobileSearch(this)) {
            toggleSuggestionsIcon('close');
            applyModals(this);
            $(this).closest('.site-search').addClass('active');
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $('.suggestions .item');
        if ($(suggestionsList).length) {
            $('input.search-field').attr('aria-describedby', 'search-result-count');
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }
    } else {
        $suggestionsWrapper.hide();
        $(this).closest('.site-search').removeClass('active');
    }
}

function fetchSFCCSuggestions(scope, term) {
    var endpoint = getSuggestionsEndpoint(scope);

    if (!endpoint) {
        processResponse.call(scope, {});
        return;
    }

    $.ajax({
        context: scope,
        url: endpoint + encodeURIComponent(term),
        method: 'GET',
        success: processResponse,
        error: function () {
            processResponse.call(scope, {});
        }
    });
}

function fetchNostoSuggestions(scope, term) {
    var requestPayload = {
        query: term,
        products: {
            from: 0,
            size: NOSTO_AUTOCOMPLETE_LIMIT,
            fields: ['productId', 'name', 'url', 'imageUrl']
        }
    };

    if (typeof window.nostojs !== 'function') {
        fetchSFCCSuggestions(scope, term);
        return;
    }

    window.nostojs(function (api) {
        Promise.resolve(api.search(requestPayload, {
            track: false,
            redirect: false
        })).then(function (response) {
            var node = extractNostoSearchNode(response);
            var hits = node && node.products && Array.isArray(node.products.hits) ? node.products.hits : [];
            var nostoMarkup = buildNostoSuggestionsMarkup(term, hits);

            if (nostoMarkup) {
                processResponse.call(scope, nostoMarkup);
            } else {
                processResponse.call(scope, {});
            }
        }).catch(function () {
            fetchSFCCSuggestions(scope, term);
        });
    });
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    var term = $(scope).val();
    var provider = getAutocompleteProvider(scope);

    if (term.length >= minChars) {
        if (provider === 'nosto') {
            fetchNostoSuggestions(scope, term);
            return;
        }

        fetchSFCCSuggestions(scope, term);
        return;
    }

    toggleSuggestionsIcon('search');
    $(scope).siblings('.reset-button').removeClass('d-lg-block');
    $(scope).closest('.site-search').removeClass('active');
    clearModals();
    getSuggestionsWrapper(scope).empty();
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var suggestionsList = $('.suggestions .item');
    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
        $('input.search-field').each(function () {
            $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).removeAttr('aria-selected');
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass('selected');
                    suggestionsList.eq(idx).attr('aria-selected', true);
                    $(this).removeProp('aria-selected');
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass('selected');
                    suggestionsList.first().attr('aria-selected', true);
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

module.exports = function () {
    $('form[name="simpleSearch"]').submit(function (e) {
        var suggestionsList = $('.suggestions .item');
        if (suggestionsList.filter('.selected').length !== 0) {
            e.preventDefault();
            suggestionsList.filter('.selected').find('a')[0].click();
        }
    });

    $('input.search-field').each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 300);
        $(this).on('keyup focus', function (e) {
            // Capture Down/Up Arrow Key Events
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                default:
                    debounceSuggestions(this, e);
            }
        });
    });

    $('body').on('click', function (e) {
        if (!$('.suggestions').has(e.target).length && !$(e.target).hasClass('search-field') && !$(e.target).hasClass("fa-search") && !$(e.target).hasClass('Search')) {
            $('.suggestions').hide();
           // $(".search-field").val("");
            //toggleSuggestionsIcon('search');
            tearDownSuggestions();
        }
    });

    $('body').on('click touchend', '.search-mobile button.fa-close', function (e) {
        e.preventDefault();
        $('.suggestions').hide();
        $(".search-field").val("");
        toggleSuggestionsIcon('search');
        tearDownSuggestions();
        $(this).closest('.site-search').removeClass('active');
    });

    $('.site-search .reset-button').on('click', function () {
        $(this).removeClass('d-lg-block');
    });

    $('.refinements-mobile-clp').on('click', '.refinement-header', function (e) {
        e.stopPropagation();
        $(this).toggleClass('active');
    });

    // handle toggle refinement block - Mobile Viewport
    if (window.matchMedia('(max-width: 768px)').matches) {
        $('.refinements-mobile-clp').on('click', '.menu-group label', function () {
            $(this).parents('.menu-group').toggleClass('active');
        });
    }
    
};

